import { faClone } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { IconButton, Tooltip } from "@mui/material";

export const SplitAction = (props: { onClick: () => void }) => {
    return (
        <Tooltip title={"Split"}>
            <IconButton onClick={() => props.onClick()}>
                <FontAwesomeIcon icon={faClone} style={MirageTheme.icons.sizeS} />
            </IconButton>
        </Tooltip>
    );
};
